import React from 'react';
import { Card } from '@sendgrid/ui-components/card';
import Uber from '../../images/signup-confidence/uber-logo.svg';
import Yelp from '../../images/signup-confidence/yelp-logo.svg';
import Airbnb from '../../images/signup-confidence/airbnb-logo.svg';
import Spotify from '../../images/signup-confidence/spotify-logo.svg';
import Glassdoor from '../../images/signup-confidence/glassdoor-logo.svg';
import Instacart from '../../images/signup-confidence/instacart-logo.svg';
import DancingPeople from '../../images/signup-confidence/dancing-people.svg';
import Styles from './signupConfidenceVariation2.module.scss';

const description = 'Over 80,000 customers trust Twilio SendGrid as their email platform';

const SignupConfidenceVariation2 = () => (
  <div className={Styles.signupConfidenceVariation2Container}>
    <Card className={Styles.signupConfidenceVariation2Card}>
      <h2>{description}</h2>
      <div className={Styles.signupConfidenceVariation2Logos}>
        <img src={Uber} alt="Uber" />
        <img src={Spotify} alt="Spotify" />
        <img src={Yelp} alt="Yelp" />
        <img src={Glassdoor} alt="Glassdoor" />
        <img src={Airbnb} alt="Airbnb" />
        <img src={Instacart} alt="Instacart" />
      </div>
      <img
        className={Styles.signupConfidenceVariation2Img}
        src={DancingPeople}
        alt="Dancing People"
      />
    </Card>
  </div>
);

export default SignupConfidenceVariation2;
